Ext.define('SA.FocusVisibilityToggler', {
    singleton: true,

    init() {
        document.body.addEventListener('keyup', this.onBodyKeyUp.bind(this), {capture: true});
        document.body.addEventListener('mousedown', this.onBodyMouseDown.bind(this), {capture: true});
    },

    onBodyKeyUp(ev) {
        if (ev.code === 'Tab') {
            document.body.classList.add('sa-with-visible-focus');
        }
    },

    onBodyMouseDown() {
        document.body.classList.remove('sa-with-visible-focus');
    }
});